import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import api from '../utils/api';
import { toast } from 'react-toastify';

export const getAllBomThunk = createAsyncThunk(
    'bom/getAllSchedule',
    async (config, { rejectWithValue }) => {
        try {
            const response = await api.getAllbomEnq(config);
            //   console.log("nnnnn",response.data);
            return response.data;
        } catch (error) {
            console.log(error);
        }
    }
);


export const getbomStatisticsThunk = createAsyncThunk(
    'bom/getbomStatisticsThunk',
    async (config, { rejectWithValue }) => {
        try {
            const response = await api.getBomEnqStatistics(config);
              console.log("staticssssssss",response.data?.data);
            return response.data?.data;
        } catch (error) {
            console.log(error);
        }
    }
);


export const bomDetailsThunk = createAsyncThunk(
    'bom/bomDetailsThunk',
    async (id, { rejectWithValue }) => {
        try {
            const response = await api.getbomDetails(id);

            return response.data?.data;
        } catch (error) {
            console.log(error);
        }
    }
);

export const exportBomThunk = createAsyncThunk(
    'order/exportBomThunk',
    async (config, { rejectWithValue }) => {
        try {
            const response = await api.getAllbomEnq(config);
            //   console.log(response.data?.data);
            return response.data;
        } catch (error) {
            console.log(error);
        }
    }
);

export const deletebomThunk = createAsyncThunk(
    'order/deleteorder',
    async (id, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.deleteBomEnq(id);
            dispatch(setbomrefresh())
            toast.success('bom enquiry deleted successfully')
            return response.data?.data;
        } catch (error) {
            console.log(error);
            toast.error(error?.response?.data?.message || 'unable to delete bom enquiry')
        }
    }
);

export const deleteProductFrombomThunk = createAsyncThunk(
    'bom/deleteprofrombom',
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.deleteProductFrombomenq(data);
            dispatch(setbomrefresh())
            toast.success('product deleted from enquiry  successfully')
            return response.data?.data;
        } catch (error) {
            console.log(error);
            toast.error(error?.response?.data?.message || 'unable to delete product')
        }
    }
);

export const updateProductFromScheduleThunk = createAsyncThunk(
    'order/updateProductFromSchedule',
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.updateProductFrombomenq(data);
            dispatch(setbomrefresh())
            toast.success('product updated from enquiry  successfully')
            return response.status;
        } catch (error) {
            console.log(error);
            toast.error(error?.response?.data?.message || 'unable to update product')
        }
    }
);

export const getAlterProductsThunk = createAsyncThunk(
    'bom/getAlterProductsThunk  ',
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.getBomAlternateProducts(data);
            console.log(response.data); 
            
            return response.data?.data;
        } catch (error) {
            console.log(error);
        }
    }
);


export const getMatchedProductsThunk = createAsyncThunk(
    'bom/getMatchedProductsThunk',
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.getMatchedProducts(data);
            return response.data?.data;
        } catch (error) {
            console.log(error);
        }
    }
);


export const getSuppliersThunk = createAsyncThunk(
    'bom/getSuppliersThunk',
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.getSuppliers(data);
            return response.data?.data;
        } catch (error) {
            console.log(error);
            toast.error(error?.response?.data?.message || 'Failed to load suppliers');
            return rejectWithValue(error?.response?.data);
        }
    }
);


export const createbomQuoteThunk = createAsyncThunk(
    'bom/createbomQuoteThunk',  
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.createBomQoute(data);
            console.log(response.data);
            dispatch(setbomrefresh())
            toast.success('quote updated successfully')
            return response.data?.data;
        } catch (error) {
            console.log(error);
            toast.error(error?.response?.data?.message || 'something went wrong')
        }
    }
);


const bomenqSlice = createSlice({
    name: 'bom',
    initialState: {
        bomenquiry: [],
        bomEnquiryDetails: {},
        bomenquiryStatistics: {
            data: {},
            loading: false
        },
        suppliers:{
            data:[],
            loading:false
        },
        macthedProducts:[],
        refresh: false,
        loading: false,
        alterProducts:{},
        alterLoading:false,
        exportLoading: false,
        error: null,
        selectedTab: 0,
        page: 1,
        search: '',
        status: '',
        fromDate: '',
        toDate: '',
    },
    reducers: {

        setbomrefresh: (state, action) => {
            state.refresh = !state.refresh;
        },
        setbomPage: (state, action) => {
            state.page = action.payload
        },
        setbomSearch: (state, action) => {
            state.search = action.payload
        },
        setbomStatus: (state, action) => {
            state.status = action.payload
        },
        setbomFromDate: (state, action) => {
            state.fromDate = action.payload
        },
        setbomToDate: (state, action) => {
            state.toDate = action.payload
        },
        setbomSelectedTab: (state, action) => {
            state.selectedTab = action.payload
        },
        setbomData: (state, action) => {
            state.orderDetails = {
                ...state.orderDetails, // Keep existing fields
                products: action.payload, // Update only products
            };
        },
        deleteAlterProduct: (state, action) => {
            const partNumberToRemove = action.payload; 
        
            state.alterProducts.alternateProducts = state.alterProducts.alternateProducts?.filter(
                (i) => {
                    const productNumber = Array.isArray(i?.productOverview?.productNumber)
                        ? i.productOverview.productNumber.join("") 
                        : i?.productOverview?.productNumber; 
        
                    return productNumber !== partNumberToRemove; 
                }
            );
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAllBomThunk.pending, (state) => {
                state.loading = true;
            })
            .addCase(getAllBomThunk.fulfilled, (state, action) => {
                state.loading = false;
                state.bom = action.payload;
            })
            .addCase(getAllBomThunk.rejected, (state, action) => {
                state.loading = false;
            })


            .addCase(getAlterProductsThunk.pending, (state) => {
                state.alterLoading = true;
            })
            .addCase(getAlterProductsThunk.fulfilled, (state, action) => {
                state.alterLoading = false;
                state.alterProducts = action.payload
            })
            .addCase(getAlterProductsThunk.rejected, (state, action) => {
                state.alterLoading = false;
            })

            //details
            .addCase(bomDetailsThunk.pending, (state) => {
                state.loading = true;
            })
            .addCase(bomDetailsThunk.fulfilled, (state, action) => {
                state.loading = false;
                state.bomEnquiryDetails = action.payload;
            })
            .addCase(bomDetailsThunk.rejected, (state, action) => {
                state.loading = false;
            })

            //details
            .addCase(exportBomThunk.pending, (state) => {
                state.exportLoading = true;
            })
            .addCase(exportBomThunk.fulfilled, (state, action) => {
                state.exportLoading = false;
            })
            .addCase(exportBomThunk.rejected, (state, action) => {
                state.exportLoading = false;
            })

            //statistics
            .addCase(getbomStatisticsThunk.pending, (state) => {
                state.bomenquiryStatistics.loading = true;
            })
            .addCase(getbomStatisticsThunk.fulfilled, (state, action) => {
                state.bomenquiryStatistics.loading = false;
                state.bomenquiryStatistics.data = action.payload
            })
            .addCase(getbomStatisticsThunk.rejected, (state, action) => {
                state.bomenquiryStatistics.loading = false
            })

            .addCase(getMatchedProductsThunk.pending, (state) => {
                state.loading = true;
            })
            .addCase(getMatchedProductsThunk.fulfilled, (state, action) => {
                state.loading = false;
                state.macthedProducts = action.payload
            })
            .addCase(getMatchedProductsThunk.rejected, (state, action) => {
                state.loading = false;
            })


            .addCase(getSuppliersThunk.pending, (state) => {
                state.suppliers.loading = true;
                state.suppliers.data = [];
            })
            .addCase(getSuppliersThunk.fulfilled, (state, action) => {
                state.suppliers.loading = false;
                state.suppliers.data = action.payload
            })
            .addCase(getSuppliersThunk.rejected, (state, action) => {
                state.suppliers.loading = false;
            })
    },
});

export const { setbomrefresh, setbomPage, setbomSearch, setbomStatus, setbomFromDate, setbomToDate, setbomSelectedTab, setbomData,deleteAlterProduct } = bomenqSlice.actions
export default bomenqSlice.reducer;

